import Popup from "../../../../../../components/popup";
import styles from "./OptionsHandler.module.css";

import { Options } from "./options";
import { useOptionsHandler } from "./hooks/useOptionsHandler";

import { GroupsSidebar } from "./components/GroupsSidebar";
import { GroupDetail } from "./components/GroupDetail";

export const OptionsHandler = ({ isOpen, togglePopup, initialGroupId = null }) => {
  const {
    // state
    allGroupOptions,
    selectedGroupId,
    groupActive,
    groupNameDraft,
    optionDrafts,
    isMainGroupDraft,

    // setters
    setSelectedGroupId,
    setGroupNameDraft,
    setOptionDrafts,

    setIsMainGroupDraft,

    // actions
    newGroup,
    saveGroupName,
    newOption,
    saveOptionName,
    addGroupToProduct,
  } = useOptionsHandler(initialGroupId);

  const Content = (
    <>
      <div className={styles.wrapper}>
        <GroupsSidebar
          styles={styles}
          groups={allGroupOptions}
          selectedGroupId={selectedGroupId}
          onSelect={setSelectedGroupId}
          onNewGroup={newGroup}
        />

        <GroupDetail
          styles={styles}
          groupActive={groupActive}
          groupNameDraft={groupNameDraft}
          setGroupNameDraft={setGroupNameDraft}
          optionDrafts={optionDrafts}
          setOptionDrafts={setOptionDrafts}
          onSaveGroupName={saveGroupName}
          onNewOption={newOption}
          onSaveOptionName={saveOptionName}
          onAddGroupToProduct={addGroupToProduct}
          isMainGroupDraft={isMainGroupDraft}
          setIsMainGroupDraft={setIsMainGroupDraft}
        />
      </div>
      <div className="mt-3">
        <Options />
      </div>
    </>
  );

  return <Popup isOpen={isOpen} togglePopup={togglePopup} content={Content} />;
};
